import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "universal-cookie";
import apiError from "@/errors/api.error";
import {
  addErrorNotification,
  addInfoNotification,
} from "@/components/framework/notify";

export default () => {
  return useMutation({
    mutationKey: ["uploadPersonalDocumentToCompanyFolder"],
    mutationFn: async ({ companyId, targetFolder, documentPath }) => {
      try {
        const res = await axios.post(
          `/api/gateway/personal-documents/companies/${companyId}/folders`,
          {
            documentPath,
            folderId: targetFolder,
          },
          {
            headers: {
              authorization: `Bearer ${new Cookies().get("accessToken")}`,
            },
          },
        );

        return res.data;
      } catch (e) {
        throw apiError.create(e.response.data.message);
      }
    },
    onSuccess: () => {
      addInfoNotification({
        tid: "success",
      });
    },
    onError: (error) => {
      addErrorNotification({
        tid: "generic.unknown_error",
        message: error.message,
      });
    },
  });
};
